'use client';

import { useFindCategoriesQuery } from '../../query/useFindFacetsQuery';
import { useFindSectionsQuery } from '../../query/useFindSectionsQuery';
import FlyoutMenuCampaign from './FlyoutMenuCampaign';
import FlyoutMenuCategory from './FlyoutMenuCategory';
import FlyoutMenuSelections from './FlyoutMenuSelections';

function NavBar() {
  // const { data: sections } = useFindSectionsQuery();
  const { data: facets } = useFindCategoriesQuery();

  return (
    <nav className="tw-container tw-mx-auto tw-flex tw-flex-nowrap tw-items-center tw-gap-3 lg:tw-gap-6 tw-px-4 lg:tw-px-6 xl:tw-px-8 tw-overflow-x-auto">
      {facets?.categories.map((category) => (
        <FlyoutMenuCategory key={`flyout-${category.id}`} category={category} />
      ))}
      <div className="tw-w-px tw-h-6 tw-bg-greyscale-separator" />
      {/* <FlyoutMenuCampaign campaigns={sections?.campaigns || []} /> */}
      <FlyoutMenuSelections />
    </nav>
  );
}

export default NavBar;
